import styled from 'styled-components';

export const Dropdown = styled.div`
  position: absolute;
  z-index: 10;
  bottom: -20px;
  transform: translateY(100%);

  width: ${({ floatingWidth }) => floatingWidth ? 'auto !important' : '300px'};
  padding: ${({ noPadding }) => noPadding ? 0 : '20px'};
  padding-bottom: ${({ noButton }) => noButton ? 0 : '50px'};;

  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  overflow: hidden;

  @media(min-width: 700px) {
    min-width: ${({ floatingWidth }) => floatingWidth ? 'auto' : '300px'};
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;

  margin: 0;
  padding: 0;
  padding-right: 10px;
  padding-top: 5px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50px;
  height: 50px;

  background-color: transparent;
  background-image: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
  box-shadow: 0 0 20px rgba(30, 182, 255, 0.24);
  border: none;
  border-radius: 100px 0 0 0;
  outline: none;

  cursor: pointer;

  svg {
    stroke: ${({ theme }) => theme.white}
  }
`;
